"use client";
import Script from "next/script";

export default function SeoScript({ jsonLd }: { jsonLd?: string }) {
  if (!jsonLd) return null;
  return (
    <Script id="page-jsonld" type="application/ld+json"
strategy="afterInteractive">
      {jsonLd}
    </Script>
  );
}